// Integration groups
export enum IntegrationGroup {
  OGLASNICI = "oglasnici",
  FINANCIJE = "financije",
  OSIGURANJA = "osiguranja",
}

// Integration IDs
// Vrijednosti prate `SalesChannel.IntegrationId` na backendu — po njima se zna
// koji je oglasnik dostupan pri unosu oglasa.
export enum IntegrationId {
  NJUSKALO = "njuskalo",
  INDEX_OGLASI = "index_oglasi",
  PLAVI_OGLASNIK = "plavi_oglasnik",
  MER = "mer",
  EPOSLOVANJE = "eposlovanje",
}

// Integration status
export enum IntegrationStatus {
  NOT_INSTALLED = "not_installed",
  INSTALLED = "installed",
  CONFIGURED = "configured",
}

// Integration definition
export interface Integration {
  id: IntegrationId;
  name: string;
  description: string;
  group: IntegrationGroup;
  icon: string;
  status: IntegrationStatus;
  settings?: IntegrationSettings;
}

// Base settings interface
export interface IntegrationSettings {
  [key: string]: string | number | boolean | undefined;
}

// Njuskalo settings
export interface NjuskaloSettings extends IntegrationSettings {
  username: string;
  password: string;
}

// Mer settings
export interface MerSettings extends IntegrationSettings {
  username: string;
  password: string;
  companyId: string;
  companyBu: string;
  softwareId: string;
  environment: "production" | "sandbox";
}

// Eposlovanje settings
export interface EposlovanjeSettings extends IntegrationSettings {
  apiKey: string;
  companyVatId: string;
  businessUnit: string;
  software: string;
  environment: "production" | "sandbox";
}

// Integration group info for display
export interface IntegrationGroupInfo {
  id: IntegrationGroup;
  name: string;
  description: string;
}
